import { render, staticRenderFns } from "./StepTOC.vue?vue&type=template&id=c70f353e&scoped=true&"
import script from "./StepTOC.vue?vue&type=script&lang=js&"
export * from "./StepTOC.vue?vue&type=script&lang=js&"
import style0 from "./StepTOC.vue?vue&type=style&index=0&id=c70f353e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70f353e",
  null
  
)

export default component.exports